var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopyInterconsulta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1 11.6833C3.78888 11.6833 3.52222 11.5722 3.29999 11.35C3.07777 11.1278 2.96666 10.8611 2.96666 10.55V1.28333C2.96666 0.972216 3.07777 0.705549 3.29999 0.483327C3.52222 0.261105 3.78888 0.149994 4.1 0.149994H11.3667C11.6778 0.149994 11.9444 0.261105 12.1667 0.483327C12.3889 0.705549 12.5 0.972216 12.5 1.28333V10.55C12.5 10.8611 12.3889 11.1278 12.1667 11.35C11.9444 11.5722 11.6778 11.6833 11.3667 11.6833H4.1ZM4.1 10.55H11.3667V1.28333H4.1V10.55ZM1.96666 13.8167C1.65555 13.8167 1.38888 13.7056 1.16666 13.4833C0.944439 13.2611 0.833328 12.9944 0.833328 12.6833V3.23333C0.833328 3.07777 0.886106 2.94444 0.991662 2.83333C1.09722 2.72222 1.23333 2.66666 1.39999 2.66666C1.56666 2.66666 1.70277 2.72222 1.80833 2.83333C1.91388 2.94444 1.96666 3.07777 1.96666 3.23333V12.6833H9.26666C9.42222 12.6833 9.55555 12.7389 9.66666 12.85C9.77777 12.9611 9.83333 13.0944 9.83333 13.25C9.83333 13.4167 9.77777 13.5528 9.66666 13.6583C9.55555 13.7639 9.42222 13.8167 9.26666 13.8167H1.96666ZM4.1 1.28333V10.55V1.28333Z",
    fill: "#3D4349"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyInterconsulta);
export default __webpack_public_path__ + "static/media/IconCopyInterconsulta.12dccf5503db9f36a891f1f246a3d34a.svg";
export { ForwardRef as ReactComponent };